module.exports = __webpack_public_path__ + "static/media/shop2.a6b10d6f.png";